import { useQuery } from '@tanstack/react-query';
import { supabase } from '@supabaseClient';
import cryptoPriceService from "@/services/investments/crypto/CryptoPriceService.ts";

export function useFetchCryptoPrices(symbols: string[]) {
  return useQuery({
    queryKey: ['crypto_prices', symbols],
    queryFn: async () => {
      return await cryptoPriceService.fetchPrices(symbols);
    },
    enabled: symbols.length > 0,
    refetchInterval: 60000,
  });
}

export function useFetchCryptoPriceChart(symbol: string, days: number = 7) {
  return useQuery({
    queryKey: ['crypto_chart', symbol, days],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('crypto-price', {
        body: { type: 'chart', symbol, days },
      });
      if (error) throw error;
      return data as Array<[number, number]>;
    },
    enabled: !!symbol,
  });
}
